import { useEffect, useState } from 'react';

const useFilteredSchedules = (
    schedules: any[],
    addressId: number | number[]| null,
    doctorIds: any
) => {
    const [filteredSchedules, setFilteredSchedules] = useState<any[]>([]);

    useEffect(() => {
        if (!schedules || schedules.length === 0) {
            setFilteredSchedules([]);
            return;
        }

        if (addressId === null && (doctorIds === null || (Array.isArray(doctorIds) && doctorIds.length === 0))) {
            setFilteredSchedules(schedules);
            return;
        }

        const filtered = schedules.filter(schedule => {
            const matchAddress = addressId === null || (Array.isArray(addressId)
                ? addressId.includes(schedule.address_id)
                : schedule.address_id === addressId);
            const matchDoctorIds = doctorIds === null || (Array.isArray(doctorIds) && doctorIds.length === 0) ||
                parseSchDoctorIds(schedule.sch_doctor_ids).some(id => (Array.isArray(doctorIds) ? doctorIds : [doctorIds]).includes(id));

            return matchAddress && matchDoctorIds;
        }).map(schedule => {
            if (doctorIds !== null && !(Array.isArray(doctorIds) && doctorIds.length === 0)) {
                const idsToMatch = Array.isArray(doctorIds) ? doctorIds : [doctorIds];
                const matchedDoctorIds = parseSchDoctorIds(schedule.sch_doctor_ids).filter(id => idsToMatch.includes(id));
                return { ...schedule, sch_doctor_ids: matchedDoctorIds };
            }
            return schedule;
        });

        setFilteredSchedules(filtered);
    }, [schedules, addressId, doctorIds]);

    const parseSchDoctorIds = (schDoctorIds: string | string[]): number[] => {
        if (Array.isArray(schDoctorIds)) {
            return schDoctorIds.map(id => parseInt(id, 10)).filter(id => !isNaN(id));
        } else if (typeof schDoctorIds === 'string') {
            return schDoctorIds.split(',').map(id => parseInt(id, 10)).filter(id => !isNaN(id));
        } else {
            console.error('Unexpected type for sch_doctor_ids:', typeof schDoctorIds);
            return [];
        }
    };

    return filteredSchedules;
};

export default useFilteredSchedules;
